import { Box, Typography } from '@material-ui/core';
import { Filter, SGSButton, SGSCard, SGSColumnFilter, SGSHelpButton, SGSTableCtrl, SGSTooltip } from 'components';

import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Affiliated } from 'core/models';
import { exportIncapacite } from 'core/services/affilie';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell, ColumnInterface } from 'react-table';
import { affilieService, menusService } from '../../../core/services';
import styles from './Affiliates.module.scss';

import classNames from 'classnames';
import { useAppContext } from 'core/contexts';
import { useQueryConf } from 'core/utils/useQuery';
import { FormProvider, useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { filtersChanged, pageChanged, pageSizeChanged, sortByChanged } from './searchParamsSliceAffiliatePrev';

import SGSModalBlue from 'components/Modal';
import { hasRole } from 'core/utils/roles';
import { StatusIncapiciteIcon } from 'features/dossierIncapacite/StatusIncapiciteIcon';
import SearchAndTable from './SearchAndTable '; //
import { resetSearchParams } from './searchParamsSliceAffiliatePrev';

type Props = {};

const AffiliatesPrev: React.FC<Props> = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const history = useHistory();
    const { user } = useAppContext();
    let searchParams = useSelector((state: any) => state.searchParamsAffiliatePrev.value);
    const [downloading, setDownloading] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);

    // Load menu data
    const { isLoading: isLoadingCSP, data: dataCSP } = useQuery([user.login, 'CSP'], async () => await menusService.getMenuCSP(), useQueryConf);
    const { isLoading: isLoadingSouscripteurs, data: dataSouscripteurs } = useQuery([user.login, 'souscripteurs'], async () => await menusService.getMenuSouscripteurs(), useQueryConf);
    const { isLoading: isLoadingNature, data: dataNature } = useQuery([user.login, 'sinisterNautures'], async () => await menusService.getMenuSinisterNatures(), useQueryConf);

    useEffect(() => {
        // Reset search
        return () => {
            dispatch(resetSearchParams());
        };
    }, []);

    /**
     * Handles the change of filter value.
     * Resets the page to 1 and sets the new filter
     *
     * @param {string} value - The new filter value.
     */
    const handleChangeFilter = (value) => {
        dispatch(pageChanged(1));
        setActiveFilters(value);
    };

    // Reset searchParam
    // useEffect(() => {
    //     const queryParams = new URLSearchParams(window.location.search);
    //     const keepNav = queryParams.get('noreset');
    //     if (!keepNav) {
    //         searchParams = JSON.stringify(INITIAL_SEARCH_PARAMS);
    //         setActiveFilters([]);
    //         dispatch(resetSearchParams());
    //     }
    // }, []);

    // Load affilies
    const {
        isLoading: isLoadingAffiliates,
        isFetching,
        data: dataAffiliates,
    } = useQuery(
        [user.login, 'indemnisation', searchParams],
        async () => {
            const { page, pageLimit, sortBy, search } = JSON.parse(searchParams);
            // search only prev affiliate
            const sortPayload = sortBy.length ? createSortPayload(sortBy[0].id, sortBy[0].desc) : [];
            return await affilieService.getAffiliesWithCompensation(page, pageLimit, sortPayload, search);
        },
        { ...useQueryConf },
    );

    // Load nature sinistre (search)

    const affiliates = dataAffiliates?.data ?? [];
    const totalPages = dataAffiliates?.totalPage ?? 0;
    const totalResults = dataAffiliates?.totalResultat ?? 0;

    const isLoadingData = isLoadingAffiliates || isFetching;

    const handleDetails = (row: any) => {
        history.push(`/affiliations/${row.original.codAffilie}/indemnisation`);
    };

    const handleExport = () => {
        setDownloading(true);
        exportIncapacite(activeFilters)
            .then((data) => {
                const url = window.URL.createObjectURL(
                    new Blob([data as BlobPart], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    }),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `incapacite.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .finally(() => {
                setDownloading(false);
            });
    };

    const columns = useMemo<ColumnInterface<Affiliated>[]>(
        () => [
            {
                id: 'status',
                Header: '',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} justify-content-center text-center`,
                accessor: (row: Affiliated) => `${row.status} ${row.lbStatut}`,
                minWidth: 50,
                maxWidth: 50,
                disableFilters: true,
                Cell: ({ row: { original: row } }: Cell<Affiliated>) => {
                    const step = row.blAlert === '1' ? '3' : row.status;
                    return (
                        <SGSTooltip className="text-center" title={<Box>{row.lbStatut}</Box>}>
                            <Box>{StatusIncapiciteIcon(step.toString())}</Box>
                        </SGSTooltip>
                    );
                },
                options: {
                    display: false,
                },
            },
            {
                Header: t('affiliations.affiliates.namesAndNIR'),
                accessor: (row: Affiliated) => `${row.nom} ${row.prenom} ${row.numSecu}`,
                id: 'nom', // Required because our accessor is a function
                minWidth: 200,
                disableFilters: true,
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell}`,
                Cell: (props: any) => {
                    const { rows, row } = props;
                    if (row.index === 0 || rows[row.index - 1].cells[1].value !== rows[row.index].cells[1].value) {
                        return (
                            <Box>
                                <Box className={styles.strong}>
                                    {row.original.nom} {row.original.prenom}
                                </Box>
                                <Box>{row.original.numSecu}</Box>
                            </Box>
                        );
                    }

                    return null;
                },
            },
            {
                Header: 'Sinistre',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell}`,
                accessor: 'Sinistre',
                maxWidth: 130,
                disableFilters: true,
                Cell: ({ row: { original: row } }) => {
                    return (
                        <Box component={'span'}>
                            {row.lbNatureSinistre} du {moment(row.dtSinitre, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                        </Box>
                    );
                },
            },
            {
                Header: t('affiliations.affiliates.matricule'),
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} justify-content-center text-center`,
                accessor: 'matriculeEntreprise',
                maxWidth: 100,
                disableFilters: true,
            },
            // {
            //     Header: t('affiliations.affiliates.csp'),
            //     headerClassName: styles.tableBorderRight__header,
            //     className: `${styles.tableBorderRight__cell} justify-content-center text-center`,
            //     accessor: 'categorie',
            //     minWidth: 150,
            //     disableFilters: true,
            // },

            {
                Header: t('affiliations.affiliates.society'),
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell}`,
                accessor: ((row) => `${row.nomSouscripteur} ${row.siret}`) as any,
                id: 'nomSouscripteur',
                minWidth: 200,
                disableFilters: true,
                Cell: (props: any) => {
                    const { rows, row } = props;
                    if (row.index === 0 || rows[row.index - 1].cells[1].value !== rows[row.index].cells[1].value) {
                        return (
                            <Box>
                                <Box className={styles.strong}>{row.original.nomSouscripteur}</Box>
                                <Box>{row.original.siret}</Box>
                            </Box>
                        );
                    }

                    return null;
                },
            },
            // {
            //     Header: t('affiliations.affiliates.hireDate'),
            //     headerClassName: styles.tableBorderRight__header,
            //     className: `justify-content-center text-center`,
            //     id: 'dtEmbauche',
            //     accessor: ((row) => (row?.dtEmbauche ? moment(row.dtEmbauche, 'YYYY-MM-DD').format('DD/MM/YYYY') : '')) as any,
            //     maxWidth: 80,
            //     disableFilters: true,
            // },
            {
                Header: 'Dossier(s)',
                headerClassName: styles.tableBorderRight__header,
                className: `${styles.tableBorderRight__cell} justify-content-center text-center`,
                accessor: 'matriculeEntreprised',
                maxWidth: 60,
                disableFilters: true,
                Cell: (props: any) => {
                    const { rows, row } = props;
                    if (row.index === 0 || rows[row.index - 1].cells[1].value !== rows[row.index].cells[1].value) {
                        return (
                            <Box>
                                <Box className={styles.strong}>{row.original?.dossierCount}</Box>
                            </Box>
                        );
                    }

                    return null;
                },
            },
            {
                Header: '',
                accessor: 'none' as any,
                className: 'p-0 align-items-stretch',
                disableFilters: true,
                disableSortBy: true,
                minWidth: 65,
                maxWidth: 25,
                Cell: ({ row }: Cell<Affiliated>) => {
                    return (
                        <Box className={styles.actions}>
                            <SGSTooltip title={<Box>{t('details')}</Box>}>
                                <div className={styles.actions__menu} onClick={() => handleDetails(row)}>
                                    <FontAwesomeIcon icon={faEye} size="lg" />
                                </div>
                            </SGSTooltip>
                        </Box>
                    );
                },
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [t],
    );

    const filterableColumnLabels = {
        nom: { value: t('affiliations.affiliates.name'), type: 'input' },
        prenom: { value: t('affiliations.affiliates.firstname'), type: 'input' },
        numSecu: { value: t('affiliations.affiliates.NIR'), type: 'input' },
        matriculeEntreprise: { value: t('affiliations.affiliates.matricule'), type: 'input' },
        categorie: {
            value: t('affiliations.affiliates.csp'),
            type: 'autocomplete',
            options: dataCSP || [],
            isLoading: isLoadingCSP,
        },
        nomSouscripteur: {
            value: t('affiliations.affiliates.societyName'),
            type: 'autocomplete',
            options: dataSouscripteurs || [],
            isLoading: isLoadingSouscripteurs,
        },
        siret: { value: t('affiliations.affiliates.siret'), type: 'input' },
        period: { value: t('compensation.search.period'), type: 'period' },
        lbStatut: {
            value: t('compensation.search.status'),
            type: 'autocomplete',
            options: [
                { value: 0, label: 'Dossier ouvert' },
                { value: 1, label: "En cours d'indemnisation" },
                { value: 2, label: 'Clôturé' },
                //{ value: 3, label: 'Alerte' },
            ],
        },
        lbNatureSinistre: {
            value: t('compensation.search.lbNatureSinistre'),
            type: 'autocomplete',
            options: dataNature || [],
            isLoading: isLoadingNature,
        },
    };

    const parsedParams = JSON.parse(searchParams);
    const [activeFilters, setActiveFilters] = useState<Filter[]>(parsedParams.search ?? []);

    const methods = useForm({
        defaultValues: {},
    });

    const handleGoToImport = () => {
        history.push('/arrets/documents');
    };

    return (
        <>
            <SGSHelpButton />
            <Box>
                <Box display="flex" className="my-2">
                    {/* Left-aligned form provider and filter */}
                    <FormProvider {...methods}>
                        <SGSColumnFilter
                            columns={filterableColumnLabels}
                            className="mr-5"
                            filters={activeFilters}
                            onFiltersChange={handleChangeFilter}
                            //disabled={isLoadingData}
                            customLabel={t('filters.on*')}
                        />
                    </FormProvider>

                    {/* Right-aligned button */}
                    {user.features.includes('EXPORT_PRESTATION_AG2R') && hasRole(user, ['ROLE_DOCUMENTS_LIDL']) && (
                        <>
                            <Box className={'ml-2 mt-3 d-flex justify-content-center'}>
                                <Box display="flex" alignItems="center" justifyContent="center" style={{ borderBottom: '1px solid #cfcfcf', height: '39px' }}>
                                    <SGSButton color="secondary" onClick={handleGoToImport} icon="fas fa-file-upload fa-lg" className={styles.importPresta}>
                                        IMPORTER FICHIER NORMÉ
                                    </SGSButton>
                                    <SGSButton color="primary" onClick={() => setIsModalOpen(true)} icon="far fa-file-excel fa-lg" className={styles.exportPresta}>
                                        EXPORT FICHIER NORMÉ
                                    </SGSButton>
                                </Box>
                            </Box>
                        </>
                    )}
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Box sx={{ flex: '1 1 auto' }}>
                        <Typography className={styles.filtersLegend}>
                            *Les filtres se basent sur les informations recensées lors de l’adhésion. Les menus déroulants vous aideront à faire votre choix en fonction de ces éléments.
                        </Typography>
                    </Box>
                    <Box className={classNames(styles.boxTotalResults)}>
                        <Typography className={styles.totalResults}>
                            {totalResults && totalResults >= 2 ? new Intl.NumberFormat('fr-FR').format(totalResults) + ' résultats' : ''}
                            {totalResults && totalResults <= 1 ? new Intl.NumberFormat('fr-FR').format(totalResults) + ' résultat' : ''}
                        </Typography>
                    </Box>

                    <SGSButton color="primary" onClick={() => handleExport()} icon="far fa-file-excel fa-lg" className={styles.export} loading={downloading}>
                        {t('global.export')}
                    </SGSButton>
                </Box>

                <SGSCard color="default" className="w-100" contentStyle={styles.cardContent}>
                    <SGSTableCtrl
                        onRowClick={handleDetails}
                        columns={columns}
                        data={affiliates}
                        loading={isLoadingData}
                        pageCount={totalPages}
                        globalFilter={activeFilters}
                        totalResults={totalResults}
                        filtersChanged={filtersChanged}
                        pageChanged={pageChanged}
                        pageSizeChanged={pageSizeChanged}
                        sortByChanged={sortByChanged}
                        searchParams={useSelector((state: any) => state.searchParamsAffiliatePrev.value)}
                    ></SGSTableCtrl>
                </SGSCard>
            </Box>
            <SGSModalBlue isOpenModal={isModalOpen} setIsOpenModal={setIsModalOpen} title={'EXPORT FICHIER NORMÉ'}>
                <SearchAndTable setIsModalOpen={setIsModalOpen} />
            </SGSModalBlue>
        </>
    );
};

export default AffiliatesPrev;

function createSortPayload(column, order) {
    const payload = {
        column: column,
        order: order ? 'ASC' : 'DESC',
    };
    const encodedPayload = JSON.stringify(payload);
    const sortParam = `${encodedPayload}`;
    return sortParam;
}
